export default __webpack_public_path__ + "static/media/feature7_1.6457b2f9.png";